import { inject, Injectable } from '@angular/core';
import { ProfileService } from 'services/profile/profile.service';
import { OrgUserProfile } from 'interfaces/profile.interface';
import { ActivatedRouteSnapshot, CanActivateFn, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { ActionCreators } from 'features/user-profile/employer/+state/employer-user-profile.actions';
import { Store } from '@ngrx/store';
import { Selectors } from '../employer/+state/employer-user-profile.state';
import { requestCompleted } from '@certemy/common';
import { Observable } from 'rxjs';

export const profileResolver: ResolveFn<Observable<OrgUserProfile>> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
) => {
  const profileId = route.params.profileId;
  return inject(ProfileService).getProfile(profileId);
};

@Injectable()
export class UserActivateGuardService  {
  constructor(private store: Store<any>) {}

  canActivate(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    const { userId } = activatedRouteSnapshot.params;
    this.store.dispatch(new ActionCreators.GetUserData({ userId }));
    return requestCompleted(this.store.select(Selectors.getUserDataState));
  }
}

export const userActivateGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
) => {
  return inject(UserActivateGuardService).canActivate(route);
};
